import { createFileRoute } from '@tanstack/react-router';

import ChatPage from '@/screens/chat/chat/id/page';

export const Route = createFileRoute('/_app/_chat/chat/$id')({
  component: ChatPage,
});
